import TriggerCard from 'pages/AutomationEngine/Engine/Steps/TriggerCard';
import {
  dateOffsetValuesTranslated,
  isBeforeAfter,
  isDateAndTime,
} from 'pages/AutomationEngine/helpers';
import DraggableStepCard from 'pages/AutomationEngine/Engine/Steps/DraggableStepCard';

export const content = ({ step }) => step.description;

const GetDateOffset = ({ dateOffset, dateOffsetDays }, t) => {
  const dateOffsetValues = dateOffsetValuesTranslated(t);
  const label = dateOffsetValues.find(
    (item) => item.value === dateOffset
  ).label;
  if (isBeforeAfter(dateOffset)) {
    return `${dateOffsetDays} ${label}`;
  }
  return label;
};

export const getDateOffset = (step, t) => GetDateOffset(step, t);

export const getDescription = ({ step, t }) => {
  const { details } = step;

  const prefix = isDateAndTime(details?.dateOffset)
    ? ''
    : ` at ${details?.time} ${details?.period}`;

  return `${GetDateOffset(details, t)} ‘${
    details?.fieldId?.label || t('[Deleted]')
  }’${prefix}`;
};

export default function Card({ step, ...others }) {
  return step?.goalType ? (
    <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>
  ) : (
    <TriggerCard {...others}>{content({ step })}</TriggerCard>
  );
}
